var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.46875 15C2.46875 8.35532 7.85532 2.96875 14.5 2.96875C16.6932 2.96875 18.7463 3.55461 20.5148 4.57765C21.0377 4.88012 21.7068 4.70144 22.0093 4.17856C22.3117 3.65568 22.133 2.9866 21.6102 2.68413C19.5177 1.47369 17.088 0.78125 14.5 0.78125C6.6472 0.78125 0.28125 7.1472 0.28125 15C0.28125 22.8528 6.6472 29.2188 14.5 29.2188C22.3528 29.2188 28.7188 22.8528 28.7188 15C28.7188 14.3959 28.2291 13.9062 27.625 13.9062C27.0209 13.9062 26.5312 14.3959 26.5312 15C26.5312 21.6447 21.1447 27.0312 14.5 27.0312C7.85532 27.0312 2.46875 21.6447 2.46875 15Z",
    fill: "#1D89D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5859 4.8359C31.013 4.40876 31.013 3.71624 30.5859 3.2891C30.1588 2.86197 29.4662 2.86197 29.0391 3.2891L14.5 17.8282L8.7109 12.0391C8.28376 11.612 7.59124 11.612 7.1641 12.0391C6.73697 12.4662 6.73697 13.1588 7.1641 13.5859L13.7266 20.1484C14.1537 20.5755 14.8463 20.5755 15.2734 20.1484L30.5859 4.8359Z",
    fill: "#1D89D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.50d8f6cc55bd49263800a0e220e99529.svg";
export { ForwardRef as ReactComponent };